const FileReadDirective = function () {
    return {
        scope: {
            fileName: "=?",
            fileSize: "=?",
            fileRead: "=",
        },
        link: function (scope, element, attributes) {

            // Once a file is loaded, if the user tries to load the
            // same file again (e.g. after making edits and re-saving it)
            // then the 'change' event won't fire unless we clear out the
            // existing data first.  The 'click' event will happen when
            // the user first clicks on the button but before they choose
            // a file.
            element.on("click", function () {
                // element.on(...) is run outside the application digest
                // $apply the changes to trigger a digest refresh.
                scope.$apply(function () {
                    scope.fileName = null;
                    scope.fileSize = null;
                    scope.fileRead = null;
                    element.val(null);
                });
            });

            element.on("change", function (changeEvent) {
                // @ts-ignore: TS2339: Property 'files' does not exist on type 'TElement'.
                var files = changeEvent.target.files;

                if (files.length > 0) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {

                        // element.on(...) is run outside the application digest
                        // $apply the changes to trigger a digest refresh.
                        scope.$apply(function () {
                            // @ts-ignore: TS2339: Property 'result' does not exist on type 'EventTarget'
                            scope.fileRead = loadEvent.target.result;
                            scope.fileSize = files[0].size;
                            scope.fileName = files[0].name;
                        });
                    }

                    // Start loading the data:
                    reader.readAsDataURL(files[0]);
                }
            });
        }
    }
};

export { FileReadDirective };